import React from "react";
import { toast, ToastOptions } from "react-toastify";
import UIDirectiveToast, { UIDirective } from "./UIDirectiveToast";

/**
 * Displays an array of UI directives as toast notifications.
 * @param directives Array of directive objects from API (each with type and message).
 * @param options (Optional) toast options to apply to all notifications (e.g., position, autoClose).
 */
export function showUIDirectives(directives: UIDirective[], options?: ToastOptions) {
  if (!directives || directives.length === 0) return;

  directives.forEach((dir) => {
    toast(<UIDirectiveToast directive={dir} />, {
      ...options,
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      toastId: `${dir.type}-${Date.now()}-${Math.random()}`,
    });
  });
}
export function withUIDirectives<T extends { ui_directives?: any[] }>(data: T): T {
  if (data?.ui_directives && Array.isArray(data.ui_directives)) {
    showUIDirectives(data.ui_directives);
  }
  return data;
}
